const toggleLeaderModal = (element, toggle) => {
  const parentElem = element.closest('.leadership__card');
  const modal = parentElem.querySelector('.leadership__modal');
  modal.classList.toggle('is-open-modal', toggle);
  toggleBodyScrollLock(toggle);
};
attachEvent('.leadership__card-modal-trigger', 'click', (ev) => {
  toggleLeaderModal(ev.target, true);
});

attachEvent('[data-close-leader-modal]', 'click', (ev) => {
  toggleLeaderModal(ev.target, false);
});
